import { IPageQueryConstraint, IPageObj } from '../nav/navtypes';
import { NavClientService } from './navclientservice';
import { NavItemAnchor } from './navitemanchor';
import { INavPageClientInfo, Model } from './navmodel';
import { NavPageItem } from './navpageitem';
import { NavPageItems } from './navpageitems';

export function IsNavPageItems<TPage extends IPageObj = any>(obj: any): obj is NavPageItems<TPage> {
    return obj instanceof NavData.NavPageItems;
}

export function IsNavPageItem<TPage extends IPageObj = any>(obj: any): obj is NavPageItem<TPage> {
    return obj instanceof NavData.NavPageItem;
}

export const NavData = {
    get NavItemAnchor() {
        return <{ new(
            Service: NavClientService,
            Source: NavPageItem | NavPageItems): NavItemAnchor<any>
        }>ResolveIndirection("NavItemAnchor");
    },

    get NavPageItems() {
        return <{
            new(Service: NavClientService, ClientInfo: INavPageClientInfo<any>,
                rawDataItems: any[], Params: IPageQueryConstraint[], AllRead: boolean): NavPageItems
        }> ResolveIndirection("NavPageItems");
    },

    get NavPageItem() {
        return <{
            new(
                ClientInfo: INavPageClientInfo,
                Service: NavClientService,
                Model: Model & Readonly<any>,
                serverData: Object,
                Anchor?: NavItemAnchor): NavPageItem
        }>  ResolveIndirection("NavPageItem");
    }
};

/** Description of Currently Needed Indirections */
export interface Indirection {
    NavPageItem: NavPageItem;
    NavPageItems: NavPageItems;
    NavItemAnchor: NavItemAnchor;
}

/**  Register Class for Indirectino */
export function RegisterIndirection<TClass extends keyof Indirection>(name: TClass, theClass: object) {
    _Indirections[name] = theClass;
}
const _Indirections: Partial<Record<keyof Indirection, object>> = {};

// Resolve Indirection to External Access
function ResolveIndirection(name: keyof Indirection) {
    const result = _Indirections[name];
    if (typeof result !== "function") {
        throw new Error(`Class Indirection for ${name} not registered`);
    }

    return result;
}
